<template>
  <div class="auth" id="auth">
    <div class="tabs">
      <el-radio-group v-model="authMethods" @change="authChange">
        <el-radio label="0">在线授权</el-radio>
        <el-radio label="1">离线授权</el-radio>
      </el-radio-group>
    </div>
    <el-form ref="form" :model="authForm" label-width="120px" :inline="true">
      <el-form-item label="上传授权文件" prop="authForm">
        <el-upload
            class="upload-demo"
            ref="grantUpload"
            name="file"
            :action="grantUrl"
            :data="carryParams"
            :auto-upload="false"
            :on-change="chooseFile"
            :on-success="grantSuccess"
            :on-error="grantError"
            multiple>
          <!--          <i class="el-icon-upload"></i>-->
          <el-button size="mini"><i style="font-size: 15px" class="el-icon-upload"></i>上传文件</el-button>
          <div class="el-upload__tip" slot="tip">支持扩展名：lic</div>
        </el-upload>
      </el-form-item>
      <template v-if="authMethods == '1'">
        <el-form-item label="机器码" prop="machineCode">
          <el-input v-model="authForm.machineCode" readonly resize="horizontal"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="exportMachineCode">导出</el-button>
        </el-form-item>
      </template>
    </el-form>
    <div class="submit_btn">
      <el-button type="primary" @click="grantAuth">提交授权</el-button>
    </div>
    <div class="content">
      <div class="auth-table">
        <CustomTable
            ref="table"
            :data="tableData"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            @selection-change="handleSelectionChange"
        >
          <el-table-column label="授权路数" prop="cameraNumber"></el-table-column>
          <el-table-column label="过期时间" prop="expireTime"></el-table-column>
          <el-table-column label="状态" prop="grantStatus"></el-table-column>
          <el-table-column label="最大并发数" prop="concurrentAbility"></el-table-column>
          <el-table-column label="更新时间" prop="updateTime"></el-table-column>
          <el-table-column label="授权能力" width="120">
            <template slot-scope="scope">
              <el-button type="primary" @click="showAbility(scope.row)">授权能力</el-button>
            </template>
          </el-table-column>
        </CustomTable>
      </div>
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageTotal">
      </el-pagination>
    </div>
    <el-dialog
        title="授权能力"
        :visible.sync="ability"
        width="30%"
        :before-close="handleClose">
      <div class="ability-item">
        <el-tag
            v-for="(item, index) in abilities"
            :key="index"
            effect="plain">
          {{ item }}
        </el-tag>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="ability = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Moment from 'moment';
import CustomTable from '@/components/KL-Table';
import API from '@/api';
import resetMessage from '@/utils/resetMessage';

export default {
  name: 'index',
  components: {
    CustomTable
  },
  data() {
    return {
      grantUrl: '/lice-cli/api/v1/owner/active',
      carryParams: {},
      pageSize: 10,
      pageTotal: 0,
      currentPage: 1,
      ability: false,
      abilities: [],
      authMethods: '0',
      authForm: {
        machineCode: ""
      },
      tableData: [],
      machineCode: ""
    };
  },
  mounted() {
    this.getAuthList();
  },
  methods: {
    // 提交授权
    grantAuth(){
      let fileLength = this.$refs.grantUpload.uploadFiles.length;
      if(!fileLength){
        this.$message.warning("请上传激活码文件")
        return;
      }
      if(this.authMethods === '1' && this.carryParams.code === ""){
        this.$message.warning("请先获取机器码")
        return;
      }
      this.$refs.grantUpload.submit();
    },
    // 查询授权列表
    getAuthList(){
      const params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize
      }
      // 先清空之前的数据
      this.tableData = [];
      this.currentPage = 1;
      this.pageTotal = 0;
      API.getAuthList(params).then(res=>{
        if(res.status === 200 && res.message === 'OK' && res.data){
          this.tableData = res.data.records;
          this.currentPage = res.data.pageNo
          this.pageTotal = res.data.total;
        }
      })
    },
    // 授权方式单选框组切换事件
    authChange(value){
      if (value === '1'){
        this.getMachineCode();
        this.grantUrl = '/lice-cli/api/v1/offLicense/active'
      }else{
        this.grantUrl = '/lice-cli/api/v1/owner/active'
        this.carryParams = {};
      }
    },
    // 获取机器码
    getMachineCode(){
      API.getMachineCode().then(res =>{
        if(res.message === "OK"){
          this.authForm.machineCode = res.data;
          this.carryParams.code = res.data;
        }else{
          this.$message.error('生成机器码错误')
        }
      })
    },
    // 导出机器码
    exportMachineCode(){
      if (!this.authForm.machineCode){
        resetMessage.warning({
          message: '机器码还未生成，请先生成机器码！',
        });
      }
      API.exportMachineCode({code: this.authForm.machineCode}).then(res=>{
        if (res.headers['content-disposition']) {
          const blob = new Blob([res.data], {
            // type: 'application/vnd.
            // openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
            type: res.headers['content-type'],
            // word文档为application/msword,
            // pdf文档为application/pdf,
            // application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8
          });
          const objectUrl = URL.createObjectURL(blob);
          const link = document.createElement('a');
          const fname = decodeURI(
              res.headers['content-disposition'].split('=')[1],
          ); // 下载文件的名字
          link.href = objectUrl;
          link.setAttribute('download', fname);
          link.style.display = 'none';
          document.body.appendChild(link);
          link.click();
          window.URL.revokeObjectURL(link.href); // 释放掉blob对象
          document.body.removeChild(link); // 下载完成移除元素
        } else {
          this.ab2str(res.data, (result) => {
            this.$message.error(result.message);
          });
        }
      })
    },
    // 显示能力
    showAbility(row){
      this.ability = true;
      this.abilities = row.abilities;
    },
    handleClose(){
      this.ability = false;
    },
    // 选择了文件后
    chooseFile(file){
      const fileType = file.name.split('.');
      if (fileType[1] !== 'lic'){
        this.$message.warning('请上传.lic格式的授权文件')
        this.$refs.grantUpload.clearFiles();
      }
    },
    // 文件上传成功后
    grantSuccess(res){
      this.$refs.grantUpload.clearFiles();
      if(res.status === 200 && res.message === 'OK'){
        this.$message.success('授权成功')
        // 授权成功后刷新授权列表
        this.getAuthList();
      }else{
        this.$message.error(res.message)}
      console.log(res)
    },
    grantError(res){
      console.log(res)
    },
    ab2str(u, f) {
      const b = new Blob([u]);
      const r = new FileReader();
      r.readAsText(b, 'utf-8');
      r.onload = function () {
        if (f) {
          f.call(null, JSON.parse(r.result));
        }
      };
    },
    formatDay(time) {
      // eslint-disable-next-line radix
      const days = parseInt(time / (1000 * 60 * 60 * 24));
      // eslint-disable-next-line radix
      const hours = parseInt((time % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      // eslint-disable-next-line radix
      const minutes = parseInt((time % (1000 * 60 * 60)) / (1000 * 60));
      // eslint-disable-next-line radix
      const seconds = parseInt((time % (1000 * 60)) / 1000);
      // eslint-disable-next-line radix
      return `${days} 天 ${hours}小时 ${minutes} 分钟 ${seconds}秒`;
    },
    handleSubmitAuth() {
      this.$refs.authForm.validate((valid) => {
        if (valid) {
          const params = {
            subjectId: this.subjectForm.id,
            ...this.authForm,
          };
          const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)',
          });
          this.$set(this.subjectForm, 'loading', true);
          API.grantSubject(params).then((res) => {
            loading.close();
            this.$set(this.subjectForm, 'loading', false);
            if (res.status === 200) {
              this.$message.success('授权成功');
              this.handleGetList();
              this.handleCloseAuthDialog();
            }else{
              this.$message.error(res.message)
            }
          }).catch(() => {
            this.$set(this.subjectForm, 'loading', false);
            loading.close();
          });
          console.log(this.subjectForm);
          console.log(this.authForm);
        }
      });
    },
    handleSizeChange(val){
      this.pageSize = val;
      this.currentPage = 1;
      this.getAuthList();
    },
    handleCurrentChange(val){
      this.currentPage = val;
      this.getAuthList();
    },
    handleSelectionChange(){
    }
  },
};
</script>
<style scoped lang="scss">
.btn-wrapper{
  .el-link{
    margin-right: 8px;
    &:last-child{
      margin-right: 0;
    }
  }
}
.auth {
  background: transparent;
  height: 100%;
  .tabs{
    margin: 20px 20px;
  }
  .el-upload__tip{
    font-size: 16px;
  }
  .submit_btn{
    margin: 20px 20px;
  }
  .title-bar {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: 20px;
    .title {
      display: flex;
      align-items: center;
      .main {
        font-size: 20px;
        font-weight: 900;
        color: rgba(0, 0, 0, 0.6);
      }
      .sub {
        font-size: 18px;
        color: rgba(0, 0, 0, 0.6);
      }
    }
  }
  .btn-handler {
    width: 160px;
  }
  .el-input{
    width: 350px;
  }

  .tools {
    display: flex;
    justify-content: space-between;

    .filter-wrapper {
      .search-input {
        width: 240px;
        height: 40px;
        font-size: 18px;
        line-height: 40px;

        /deep/ .el-input__inner {
          border-radius: 20px;
          padding-left: 35px;
        }

        /deep/ .el-input__prefix {
          left: 13px;
        }
      }
    }

    .btn-wrapper {
      /deep/ .el-button {
        width: 160px;
        height: 40px;
        color: rgba(154, 154, 154, 1);
      }

      /deep/ .el-button--primary {
        color: #fff;
      }
    }
  }
  .listLogo {
    padding-bottom: 10px;
    img {
      width: 28px;
      height: 20px;
    }
    span {
      font-size: 20px;
      padding-left: 10px;
    }
  }
  .content {
    background: rgba(255, 255, 255, 1);
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.03);
    padding: 20px;
    box-sizing: border-box;
    height: 90%;
    .auth-table{
      height:90% ;
    }
    .table {
      margin-bottom: 30px;
    }

    .pagination {
      text-align: right;
    }
  }

  .btn-table {
    font-size: 18px;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.6);
    & + .btn-table {
      margin-left: 40px;
    }
  }
  .mute {
    color: rgba(1, 195, 141, 0.43);
  }
}
</style>
<style lang="scss">
#auth {
  .saveBtn,
  .cancelBtn {
    height: 30px;
    padding: 5px 10px;
  }
  .saveBtn {
    background-color: rgba(255, 101, 91, 1);
  }
  .el-tag + .el-tag {
    margin-left: 10px;
  }
  .downLoadButton {
    background: rgba(231, 250, 241, 1);
    color: #19cc7b;
    font-family: "Microsoft YaHei";
    font-weight: 400;
    display: inline-block;
    padding: 5px 10px;
    height: 30px;
  }
  .btn-expand {
    height: 30px;
  }
  .btn-operate-edit {
    font-family: "Microsoft YaHei";
    font-weight: 400;
    color: rgba(7, 41, 92, 1);
    margin-right: 20px;
  }
  .btn-operate-download {
    font-family: "Microsoft YaHei";
    font-weight: 400;
    display: inline-block;
    padding: 5px 10px;
    color: rgba(255, 101, 91, 1);
    height: 30px;
    background: rgba(255, 239, 238, 1);
  }
  .icon-transToDown {
    transform: rotate(90deg);
  }
  .icon-transToUp {
    transform: rotate(-90deg);
  }
  .saveBtn {
    background-color: rgba(255, 101, 91, 1);
  }
}
</style>
